// @flow

const PREFIX = "/downloads";

export default class ImageHelper {
    /**
     * Return the URL for requesting local files.
     *
     * Notice: if absolute URL given in filename, it will simply return it.
     */
    static makeUrl(
        filename: string,
        extension?: string,
        options: { [key: string]: any } = {}
    ): string {
        // if absolute url, return it
        if (filename.startsWith("http")) {
            return filename;
        }

        if (extension) {
            filename = this.removeExtension(filename) + "." + extension;
        }

        let parsedOptions = this.parseOptions(options);
        if (parsedOptions.length > 0) {
            parsedOptions += "/";
        }

        return `${PREFIX}/${parsedOptions}${filename}`;
    }

    static removeExtension(filename: string): string {
        return filename.replace(/\.[^/.]+$/, "");
    }

    /**
     * Parse options object and transform it into URL-style
     *
     * Eg: width=120,height=90
     */
    static parseOptions(options: { [key: string]: any } = {}): string {
        let url = "";

        for (const option in options) {
            const value = options[option];
            url += `,${option}=${value}`;
        }

        return url.length > 0 ? url.substring(1) : url;
    }
}



// WEBPACK FOOTER //
// ./src/app/util/ImageHelper.js